import { createSlice } from '@reduxjs/toolkit'

const initialProjectState = {
  project: null,
  projectsDropdown: [],
  isProjectLimitReachedDialog: false,
}

export const ProjectSlices = createSlice({
  name: 'projects',
  initialState: initialProjectState,
  reducers: {
    project: (state, action) => {
      state.project = action.payload.project
    },
    projectsList: (state, action) => {
      state.projectsDropdown = action.payload.projects
    },
    setProjectLimitReachedDialog: (state, action) => {
      state.isProjectLimitReachedDialog = action.payload
    }
  },
})